<template>
  <div
    :id="appName"
    :class="[appCode, appName]"
    class="ccm conversational-connectors-management"
  >
    <router-view :name="appCode"></router-view>
  </div>
</template>

<script>
import { appCode, appName } from '@/common/consts';

export default {
  name: appCode,
  data() {
    return {
      basePath: '/ccm',
      appCode,
      appName,
    };
  },
  created() {
    document.title = `${this.$t(`${appCode}:conversationalCloudLabel`)}`;
  },
};
</script>

<style lang="scss">
.conversational-connectors-management {
  @include themify {
    background-color: getColor('viewBackgroundColor', $ccm);
  }
  .theme-dark & {
    background-image: url('~@/assets/images/bg.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .stepper-wrapper {
    display: flex;
    padding: 24px;
    .view {
      overflow: auto;
      width: 100%;
      justify-content: center;
      text-align: left;
      padding-top: 30px;
    }
  }

  box-sizing: border-box;
  font-family: $font-family-Roboto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  @include themify {
    color: getColor('appTextColor', $ccm);
  }
  height: 100%;

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      @include themify {
        color: getColor('navbarTextColor', $ccm);
      }

      &.router-link-exact-active {
        @include themify {
          color: getColor('activeRouterLinkTextColor', $ccm);
        }
      }
    }
  }

  .co-assistant-card {
    position: absolute;
    right: 24px;
    top: 96px;
  }

  .co-backdrop-container {
    position: fixed;
    top: 0;
    left: 0;
  }

  .form-field {
    &__label {
      font-family: $font-family-Roboto;
      font-style: normal;
      font-weight: 700;
      font-size: 13px;
      line-height: 133%;
      text-align: justify;
      @include themify {
        color: getColor('connectorFormLabelColor', $ccm);
      }
      margin: 16px 0 5px 0;

      &__tooltip {
        margin-left: 4px;
        cursor: pointer;
      }
    }

    &__select {
      width: 446px !important;
      height: 32px;
      margin-bottom: 4px;
    }

    &__select.error {
      @include themify {
        border: 2px solid getColor('inputErrorBorderColor', $ccm);
      }
    }

    &__textarea {
      width: 446px !important;
      margin-bottom: 4px;
    }

    &__textarea.error {
      @include themify {
        border: 2px solid getColor('inputErrorBorderColor', $ccm);
      }
    }

    &__counter {
      @include themify {
        color: getColor('connectorFormLabelColor', $ccm);
      }
      font-size: 11px;
      font-weight: 400;
      font-style: normal;
      letter-spacing: 0.117px;
      line-height: 150%;
    }

    .le-input-field.form-field__input {
      @include themify {
        width: 446px;
        height: 33px;
        gap: 6px;
        inset: 0;
        border-radius: 3px;
        background: getColor('connectorFormInputBgColor', $ccm);
        color: getColor('connectorFormInputColor', $ccm);
        font-family: $font-family-Roboto;
        margin: 4px 0;
      }

      &.error {
        @include themify {
          border: 2px solid getColor('connectorFormInputErrorBorderColor', $ccm);
        }
      }
    }

    &__messages.error {
      @include themify {
        color: getColor('connectorFormErrorMessageColor', $ccm);
        font-size: 11px;
      }
    }

    &__messages.info {
      @include themify {
        color: getColor('connectorFormLabelColor', $ccm);
        font-size: 11px;
        margin-bottom: 8px;
        a {
          color: getColor('connectorLinkColor', $ccm);
          text-decoration: none;
        }
      }
    }
  }
}

@font-face {
  font-family: 'Montserrat';
  src:
    local('Montserrat'),
    url('../src/assets/fonts/Montserrat-Regular.ttf') format('truetype');
}

@font-face {
  font-family: 'Inter';
  src:
    local('Inter'),
    url('../src/assets/fonts/Inter-Regular.ttf') format('truetype');
}
</style>
